import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import "./contact.css";
import { Link, NavLink } from "react-router-dom";
import tours from "../../../datebase/tours";

const Contact = ({ t, langcat, setScoreTours, scoreTours }) => {
    return (
        <>
            <div className="contact">
                <div className="container">
                    <div className="contact-flex">
                        <div className="contact-block1">
                            <div className="contact-block1-text1">
                                Контакты
                            </div>
                            <div className="contact-block1-text2">
                                Свяжитесь с нами
                            </div>
                        </div>
                        <div className="contact-block2">
                            <div className="contact-block2-box1">
                                <div className="contact-block2-box-texts">
                                    <div className="contact-block2-box-texts-text1">{t("footer-address")}</div>
                                    <div className="contact-block2-box-texts-text2">{t("address")} 121</div>
                                </div>
                                <div className="contact-block2-box-texts">
                                    <div className="contact-block2-box-texts-text1">{t("email")}</div>
                                    <a href="mailto:besqalatour@gmail.com" className="contact-block2-box-texts-text2 link">besqalatour@gmail.com</a>
                                </div>
                                <div className="contact-block2-box-texts">
                                    <div className="contact-block2-box-texts-text1">{t("phoneNumber")}</div>
                                    <a href="tel:+998913777729" className="contact-block2-box-texts-text2 link">+998 (91) 377-77-29</a>
                                    <a href="tel:+998973540024" className="contact-block2-box-texts-text2 link">+998 (97) 354-00-24</a>
                                </div>
                                <div className="contact-block2-box-texts">
                                    <div className="contact-block2-box-texts-text1">{t("socialNet")}</div>
                                    <div className="contact-block2-box-texts-span">
                                        <a href="https://t.me/urazaevtima" className="link" target="_blank">
                                            <i class="fa fa-telegram" aria-hidden="true"></i>
                                        </a>
                                        <a href="https://wa.me/998913777729" className="link" target="_blank">
                                            <i class="fa fa-whatsapp" aria-hidden="true"></i>
                                        </a>
                                        <a href="https://www.instagram.com/aral_sea_discovery" className="link" target="_blank">
                                            <i class="fa fa-instagram" aria-hidden="true"></i>
                                        </a>
                                        <a href="https://www.facebook.com/tazabay.uteuliev" className="link" target="_blank">
                                            <i class="fa fa-facebook" aria-hidden="true"></i>
                                        </a>
                                        <a href="https://www.booking.com/hotel/uz/guest-house-besqala.ru.html?aid=2311236&label=ru-uz-booking-desktop-ztIafAlYL%2ARbreYDfoIIbQS652897959005%3Apl%3Ata%3Ap1%3Ap2%3Aac%3Aap%3Aneg%3Afi%3Atikwd-65526620%3Alp1028523%3Ali%3Adec%3Adm&sid=389c08962350fa745833d7c8bb5dd466&dest_id=4803812&dest_type=hotel&dist=0&group_adults=2&group_children=0&hapos=1&hpos=1&no_rooms=1&req_adults=2&req_children=0&room1=A%2CA&sb_price_type=total&sr_order=popularity&srepoch=1775301622&srpvid=f0df4fba99e2011e&type=total&ucfs=1&" className="link" target="_blank">
                                            <i class="fa fa-bold" aria-hidden="true">.</i>
                                        </a>
                                        <a href="https://www.tripadvisor.ru/Attraction_Review-g815344-d34123376-Reviews-Aral_Sea_Discovery-Nukus_Republic_of_Karakalpakstan.html" className="link" target="_blank">
                                            <i class="fa fa-tripadvisor" aria-hidden="true"></i>
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div className="contact-block2-box2">
                                <div className="contact-block2-box-texts">
                                    <div className="contact-block2-box-texts-text1">{t("findusMaps")}</div>
                                    <div className="contact-block2-box-texts-map">
                                        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1680.2735947008064!2d59.617767731535054!3d42.4550731110056!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x41dd9b4d3f7c2ac7%3A0x7e1a039531ee6a5f!2sBesqala!5e0!3m2!1sru!2s!4v1769794785151!5m2!1sru!2s" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};
export default Contact;
